import {
  AuthenticationDataContext,
  AuthenticationDataContextProps,
} from '@/utils/providers/authetnitactionDataContext/AuthenticationDataContext.tsx';
import { useContext } from 'react';

export const useAuthenticationDataContext = (): AuthenticationDataContextProps => {
  const context = useContext(AuthenticationDataContext);
  if (!context) {
    throw new Error(
      'useAuthenticationDataContext must be used within a AuthenticationDataProvider',
    );
  }
  return context;
};
